import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { WithFooterWrapper } from '~/components/with-footer-wrapper/WithFooterWrapper';
import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/query-params';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';

import newsHeaderStyles from './components/news-header/NewsHeader.module.scss';
import { NewsView } from './components/news-view/NewsView';
import { SearchBar } from './components/search-bar/SearchBar';
import { SearchView } from './components/search-view/SearchView';
import styles from './News.module.scss';
import { useNewsSearchStore } from './stores/use-news-search-store/useNewsSearchStore';

export interface TopNewsTimeState {
  date: string;
}
export interface TopNewsReducerAction {
  date: string;
  userScrolling?: boolean;
}

export const News = () => {
  const { t } = useTranslation([
    'analyze',
    'chart',
    'countries',
    'datePicker',
    'news',
    'scenario',
    'screener',
    'widget',
  ]);

  const {
    isInputExpanded,
    setInputValue,
    setInputExpanded,
    clearSearch,
    clearActiveFilters,
  } = useNewsSearchStore(state => ({
    inputValue: state.inputValue,
    setInputValue: state.setInputValue,
    isInputExpanded: state.isInputExpanded,
    setInputExpanded: state.setInputExpanded,
    clearSearch: state.clearSearch,
    clearActiveFilters: state.clearActiveFilters,
  }));

  const { params } = useQueryParams();
  const searchQuery = params[queryKeys.searchNews] ?? '';

  useEffect(() => {
    if (searchQuery) {
      setInputValue(searchQuery);
    }
  }, []);

  useEffect(() => {
    return () => {
      setInputExpanded(false);
      clearSearch();
      clearActiveFilters(t);
    };
  }, [clearActiveFilters, clearSearch, setInputExpanded]);

  return (
    <div className={styles.newsRoot} data-testid="news">
      <div className={newsHeaderStyles.newsHeader}>
        <h1 className={styles.newsTitle}>{t('news:title')}</h1>
        <SearchBar />
      </div>
      <WithFooterWrapper
        shouldHide={!!params[queryKeys.activeDrawer]}
        trackingMetadata={{ source: POSTHOG_TRACKING_SOURCES.NEWS }}
      >
        {isInputExpanded ? (
          <SearchView searchQuery={searchQuery} />
        ) : (
          <NewsView trackingSource={POSTHOG_TRACKING_SOURCES.NEWS} />
        )}
      </WithFooterWrapper>
    </div>
  );
};
